<script setup lang="ts">
export interface TcBasicContentActionsLayoutProps {
  style?: "end-actions";
  fullHeight?: boolean;
  withPadding?: boolean;
}

const props = withDefaults(defineProps<TcBasicContentActionsLayoutProps>(), {
  style: "end-actions",
  fullHeight: true,
  withPadding: true,
});
</script>

<template>
  <div
    class="view"
    :class="{
      'view--end-actions': props.style === 'end-actions',
      'view--full-height': props.fullHeight,
      'view--with-padding': props.withPadding,
    }"
  >
    <div class="view__content">
      <slot name="content" />
    </div>

    <div class="view__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.view {
  display: grid;
  grid-template-areas: "content" "actions";

  &--end-actions {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
  }

  &--full-height {
    overflow: hidden;
    height: 100%;

    .view__content {
      @include utils.noScrollbar();

      overflow: scroll;
      height: 100%;
    }
  }

  &--with-padding {
    .view__content,
    .view__actions {
      @include sp.padding(x, 4);
      @include sp.padding(t, 4);
    }

    .view__actions {
      @include sp.padding(b, 4);
    }
  }

  &__content {
    grid-area: content;
  }

  &__actions {
    grid-area: actions;
  }
}
</style>
